import React from "react";

const SvgFacebook = props => <svg viewBox="0 0 20 20" {...props}><path fill="currentColor" fillRule="evenodd" d="M8.456 18v-7.298H6V7.857h2.456V5.76C8.456 3.325 9.943 2 12.114 2c1.04 0 1.935.077 2.195.112v2.544h-1.507c-1.18 0-1.41.562-1.41 1.385v1.817h2.817l-.367 2.845h-2.45V18H8.456z" /></svg>;

export default SvgFacebook;